import Vue from 'vue';

class HtmlService {

    private readonly focusableElSelector = 'input:not([readonly]), button:not([disabled]), select:not([readonly]),' +
        ' textarea:not([readonly]), [tabindex]:not([tabindex="-1"])';


    public focusFirstNode(root: Element, markFieldOnFocus?: boolean) {
        let node: Node | null = null;
        if (root.matches(this.focusableElSelector)) {
            // root matches the focusable selector
            node = root;
        } else {
            const focusableEls = root.querySelectorAll(this.focusableElSelector);
            if (focusableEls && focusableEls.length > 0) {
                // use first child matching focusable selector
                node = focusableEls[0];
            }
        }

        if (node && node instanceof HTMLElement) {
            node.focus();
        }

        if (markFieldOnFocus) {
            Vue.nextTick().then(() => {
                if (node && node instanceof HTMLInputElement) {
                    node.select();
                }
            });
        }
    }

}

const HTML_SERVICE_INSTANCE = new HtmlService();

export {HTML_SERVICE_INSTANCE};
